import { useEffect, useRef } from 'react';

import { ToolInvocation } from './ToolCallStatus';

interface ToolCompletionEffectProps {
  toolInvocation: ToolInvocation;
  onComplete: () => void;
}

/**
 * Fires a callback when a tool invocation transitions to the completed state.
 * Renders nothing — purely a side-effect component.
 */
export const ToolCompletionEffect = ({
  toolInvocation,
  onComplete,
}: ToolCompletionEffectProps) => {
  const hasFired = useRef(false);
  const isComplete = toolInvocation.state === 'output-available';

  useEffect(() => {
    if (isComplete && !hasFired.current) {
      hasFired.current = true;
      onComplete();
    }
  }, [isComplete, onComplete]);

  return null;
};
